import React, { useState, useEffect, useCallback } from "react";
import TableHook from "./TableHook";
import TableCardHook from "./TableCardHook";
import { useNavigate } from "react-router-dom";
import { getCryptoCurrencyListHomeForWatchlist } from "../../../../apihelper/homepage";
import { Skeleton } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import json2mq from "json2mq";
import {Button} from "@mui/material";
import AddToPortfolio from '../../../AddToPortfolio';


const CryptoWatchlist = () => {
    const navigate = useNavigate();
    const [header, setHeader] = useState([
        { label: "Crypto", key: "crypto", sorting: "asc" },
        { label: "Price", key: "price", sorting: "asc" },
        { label: "Last 30 Days", key: "thirty_day", sorting: "asc" },
        { label: "Last 1 Year", key: "one_year", sorting: "asc" },
        { label: "Grade", key: "grade" },
    ]);

    const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
    const [photoIndex, setPhotoIndex] = useState(0);
    const [loading, setLoading] = useState(false);
    const [myPortfolio, setMyPortfolio] = useState([]);
    const [filter, setFilter] = useState("");
    const [photoGalleryLoader, setPhotoGalleryLoader] = useState(true);
    const [addMoreLoader, setAddMoreLoader] = useState(false);
    const [sortOrder, setSortOrder] = useState({
        crypto: "asc",
        price: "asc",
        thirty_day: "asc",
        one_year: "asc",
    });
    const [sortKey, setSortKey] = useState("crypto");
    const [sortType, setSortType] = useState("pn_asc");

    const fetchData = useCallback(() => {
        setLoading(true);
        getCryptoCurrencyListHomeForWatchlist({
            slug: filter,
            pathname: "crypto-watchlist",
            user_id: userData?.user_id,
            start_index: 0,
            limit: "7",
        }).then((res) => {
            if (res.code === "200") {
                setMyPortfolio(res.data);
                setPhotoGalleryLoader(res.data.length >= 7);
            }
            setLoading(false);
        }).catch(() => setLoading(false));
    }, [userData, filter]);

    const loadMoreGallery = () => {
        setPhotoIndex((prev) => prev + 7);
        setAddMoreLoader(true);
        getCryptoCurrencyListHomeForWatchlist({
            slug: filter,
            pathname: "crypto-watchlist",
            user_id: userData?.user_id,
            start_index: photoIndex + 7,
            limit: "7",
        }).then((res) => {
            if (res.code === "200") {
                setMyPortfolio((prev) => [...prev, ...res.data]);
                setPhotoGalleryLoader(res.data.length >= 7);
            }
            setAddMoreLoader(false);
        }).catch(() => setAddMoreLoader(false));
    };

    const handleSort = (column) => {
        const newSortOrder = sortOrder[column] === "asc" ? "desc" : "asc";
        setSortOrder((prev) => ({ ...prev, [column]: newSortOrder }));

        const sortMapping = {
            crypto: newSortOrder === "asc" ? "pn_asc" : "pn_desc",
            price: newSortOrder === "asc" ? "pr_asc" : "pr_desc",
            thirty_day: newSortOrder === "asc" ? "td_asc" : "td_desc",
            one_year: newSortOrder === "asc" ? "sm_asc" : "sm_desc",
        };

        setSortKey(sortMapping[column]);

        setHeader((prev) =>
            prev.map((h) =>
                h.key === column
                    ? { ...h, sorting: newSortOrder }
                    : h.sorting
                        ? { ...h, sorting: "asc" }
                        : h
            )
        );
    };

    const parseForecastPrice = (price) => {
        if (!price) return 0;
        const parsed = parseFloat(price.toString().replace(/[^0-9.-]+/g, ""));
        return isNaN(parsed) ? 0 : parsed;
    };

    const getSortedData = useCallback(() => {
        const sortingFunctions = {
            pn_asc: (a, b) => a.name.localeCompare(b.name),
            pn_desc: (a, b) => b.name.localeCompare(a.name),
            pr_asc: (a, b) => parseForecastPrice(a.price_today) - parseForecastPrice(b.price_today),
            pr_desc: (a, b) => parseForecastPrice(b.price_today) - parseForecastPrice(a.price_today),
            td_asc: (a, b) => parseForecastPrice(a.thirtyd_change) - parseForecastPrice(b.thirtyd_change),
            td_desc: (a, b) => parseForecastPrice(b.thirtyd_change) - parseForecastPrice(a.thirtyd_change),
            sm_asc: (a, b) => parseForecastPrice(a.year_change) - parseForecastPrice(b.year_change),
            sm_desc: (a, b) => parseForecastPrice(b.year_change) - parseForecastPrice(a.year_change),
        };
        return [...myPortfolio].sort(sortingFunctions[sortType]);
    }, [myPortfolio, sortType]);

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        setSortType(sortKey);
    }, [sortKey]);

    useEffect(() => {
        setMyPortfolio(getSortedData());
    }, [sortType]);

    const row = myPortfolio.map(({
        name,
        slug,
        price_today,
        thirtyd_change,
        year_change,
        grade,
        logo
    }) => [
        <div key={name} className="table-col-1 d-flex" style={{alignItems:"center"}}>
            <img
                src={logo ? window.constants.asset_path + logo : window.constants.asset_path + "/images/avtar.jpeg"}
                width={39.77}
                height={38}
                style={{ borderRadius: "19px", border: "2px solid black" }}
                alt={name}
            />
            <span className="tab-text">{name}</span>
        </div>,
        price_today ?? "N/A",
        thirtyd_change ?? "N/A",
        year_change ?? "N/A",
        <div style={{ display: "flex", alignItems: "center", justifyContent:"flex-end", marginRight:"12%", gap:"20px" }}>
    <span
        style={{
            backgroundColor:
                grade === "Outperformer" || grade === "Emerging Outperformer"
                    ? "#199F5F"
                    : grade === "Moderate Performer"
                        ? "#D4AF37"
                        : grade === "Underperformer"
                            ? "#FF4141"
                            : "gray",
            color: "white",
            padding: "5px 12px",
            borderRadius: "15px",
            fontSize: "14px",
            fontWeight: "bold",
            minWidth: "140px",
            textAlign: "center",
        }}
    >
        {grade === "Emerging Outperformer" ? "Outperformer" : grade}
    </span>
               
            <AddToPortfolio
            slugName={slug}
            triggerElement={
                        <Button
                            style={{
                                marginLeft: "-10px",
                                marginRight: "-20px",
                            }}
                        >
                            <div
                                style={{
                                    display: "inline-flex",
                                    border: "1px solid #1877F2",
                                    borderRadius: "50%",
                                    padding: "3px 4px",
                                    marginLeft: "-5px",
                                }}
                            >
                                <img
                                    width="12px"
                                    src={
                                        window.constants.asset_path +
                                        "/images/plus.svg"
                                    }
                                    alt="Add"
                                />
                            </div>
                        </Button>   
            }
            />           
        </div>
,
    ]);

    const mediaQueryVar = useMediaQuery(json2mq({ minWidth: 900 }));

   

    return (
        <div className="section-3 my-5 pt-5" style={{ marginRight: mediaQueryVar ? "25px" : "" }}>
            <div className="profile-headings mt-5">
                <h1>CRYPTO WATCHLIST</h1>
            </div>
            {!loading && (
                <div className="add-crypto-watchlist-button d-flex justify-content-center mt-3">
                    <button className="d-flex align-items-center" onClick={() => navigate("/crypto-screener")}>
                        <span>ADD MORE CRYPTOS</span>
                        <img
                            src="images/profile_image/account_image/left-arrow-icon.svg"
                            className="left-arrow-icon"
                            alt="Add More Portfolio"
                        />
                    </button>
                </div>
            )}
            <TableHook
                header={header.map((h) => ({
                    ...h,
                    icon: h?.sorting ? (h.sorting === "asc" ? "↑" : "↓") : null,
                    onClick: h?.sorting ? () => handleSort(h.key) : undefined,
                }))}
                tableData={row}
                loading={loading}
            />
            {myPortfolio.map((portfolio) => (
                <TableCardHook
                    key={portfolio.name}
                    header={{
                        name: portfolio.name,
                        icon: portfolio?.logo || "/images/avtar.jpeg",
                    }}
                    body={[
                        { key: "Price", value: portfolio.price_today ? `${portfolio.price_today}` : "N/A" },
                        { key: "Last 30 Days", value: portfolio.thirtyd_change ? `${portfolio.thirtyd_change}` : "N/A" },
                        { key: "Last 1 year", value: portfolio.year_change ? `${portfolio.year_change}` : "N/A" },
                        { key: "Grade", value: portfolio.grade ? `${portfolio.grade}` : "N/A" },
                    ]}
                    footer={[
                        {
                          label: (
                            <AddToPortfolio
                              slugName={portfolio.slug}
                              triggerElement={
                                <button style={{ color: "#000", background: "none", border: "none", cursor: "pointer", fontWeight:"bold" }}>
                                  Add to Portfolio
                                </button>
                              }
                            />
                          ),
                        },
                      ]}
                      
                />
            ))}
            {loading &&
                Array.from({ length: 3 }).map((_, index) => (
                    <TableCardHook
                        key={index}
                        header={{
                            name: <Skeleton variant="rounded" height={40} width={150} />,
                            icon: <Skeleton variant="circular" height={40} width={40} />,
                        }}
                        body={[
                            { key: "Price", value: <Skeleton variant="rounded" height={30} /> },
                            { key: "Last 30 Days", value: <Skeleton variant="rounded" height={30} /> },
                            { key: "Last 1 Year", value: <Skeleton variant="rounded" height={30} /> },
                            { key: "Grade", value: <Skeleton variant="rounded" height={30} /> },

                        ]}
                        footer={[
                            { label: <Skeleton variant="text" width={100} />, icon: null },
                            { label: <Skeleton variant="text" width={120} />, icon: null },
                        ]}
                    />
                ))}
        </div>
    );
};

export default CryptoWatchlist;
